import axios from "axios";
import { endpoints } from "config/api";
import { generateAccessToken, getToken } from "./helpers/utilities";
import { axiosErrorHandler } from './helpers/axiosHelpers';

//sigin api
export const signIn = async (data) => {
  const token = generateAccessToken();
  let request = await axios({
    method: "post",
    url: endpoints.auth.SEND_OTP,
    headers: {
      // Authorization: localStorage.getItem("token"),
    },
    data: {...data,token:token},
  }).catch(axiosErrorHandler);
  return request;
};

// verify OTP
export const VerifyOtpApi = async (data) => {
  let request = await axios({
    method: "post",
    url: endpoints.auth.VERIFY_OTP,
    headers: {
      // Authorization: localStorage.getItem("token"),
    },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};

//create Password
export const CreatePasswordApi = async (data) => {
  let request = await axios({
    method: "post",
    url: endpoints.auth.CREATE_PASSWORD,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};

//Login Api
export const LoginApi = async (data) => {
  let request = await axios({
    method: "post",
    url: endpoints.auth.LOGIN,
    headers: {
      // Authorization: "Bearer " + getToken(),
    },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};

//Reset Password Api
export const ResetPasswordApi = async (data, token) => {
  let request = await axios({
    method: "PUT",
    url: endpoints.auth.RESET_PASSWORD,
    headers: {
      Authorization: "Bearer " + (token || getToken()),
    },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};

//forget Password Api
export const ForgetPasswordApi = async (data) => {
  let request = await axios({
    method: "POST",
    url: endpoints.auth.FORGET_PASSWORD,
    headers: {
      // Authorization: "Bearer " + getToken(),
    },
    data: data,
  }).catch(axiosErrorHandler);
  return request;
};



// edit availability api

//logout api call
export const logoutapi = (token) => {
  let request = axios({
    method: "post",
    url: endpoints.auth.LOGOUT,
    headers: {
      Authorization: "Bearer " + getToken(),
      source: "PATIENT WEB",
    },
  });
  return request;
};



export const GetAppointment = async ({ id }) => {
  const request = await axios({
    method: "get",
    url: endpoints.appointment.GET_APPOINTMENT + id,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      source: "DOCTOR WEB",
    },
  }).catch(axiosErrorHandler);
  return request;
};
